import parse from 'html-react-parser';
import { t } from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';

const SuccessResponse = (props) => {
  const { payment } = props;
  const { kuConfiguration } = useSelector((state) => state.conferenceDetails);

  return (
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="heading">
            {t("welcome-to-khalifa")}
            </h2>
          </div>
        </div>
        <div class="divider-10"></div>
        <div class="alert alert-primary" role="alert">
        <div><h2 class="alert-heading alert-success pl-2">{t("success")}</h2></div>
          <hr />
          <h2>
          {t("your-registration-no")} <b>{payment?.registrationNo}</b>
          </h2>

          <div> {parse(kuConfiguration?.successMailBody)}</div>
          {/* <p>
          {t("payment-inquiry")}{" "}
            <a href={`mailto:${kuConfiguration?.supportEmailAddress}`}>
              {kuConfiguration?.supportEmailAddress}
            </a>
          </p> */}
          <div class="btn btn-default">
            <button onClick={() => window.print()}>{t("print")}</button>
          </div>
        </div>
      </div>
      <footer class="footer">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              {parse(kuConfiguration?.paymentResponseCommonFooter)}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SuccessResponse;
